export default [
  {
    path: "commissions",
    name: "commissions",
    component: (): Promise<any> => import(/* webpackChunkName: "commissions" */ "@/components/Webmaster/Commissions/Commissions.vue")
  }
];
